




















import { Component, Vue } from 'vue-property-decorator';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { BButton, BIconPlus, BModal } from 'bootstrap-vue';
import DataTable from '@/components/DataTable.vue';
import OperationFilter from '@/components/OperationFilter.vue';
import OperationList from '@/components/OperationList.vue';
import OperationDetails from '@/components/OperationDetails.vue';
import OperationFilterOptions from '@/types/OperationFilterOptions';

@Component({
    components: {
        'default-layout': DefaultLayout,
        'data-table': DataTable,
        'operation-filter': OperationFilter,
        'operation-list': OperationList,
        'b-btn': BButton,
        'b-icon-plus': BIconPlus,
        'b-modal': BModal,
        'operation-details': OperationDetails
    }
})
export default class OperationsView extends Vue {
    operationId = ''
    showModal = false;
    refreshList = false;
    modalTitle = '';
    filter: OperationFilterOptions | null = null;

    onOperationSelected(id: string) {
        this.operationId = id;
        this.modalTitle = this.$t('modal.operationDetailsTitle') as string;
        this.showModal = true;
    }

    onLoadComplete() {
        this.refreshList = false;
    }

    onOperationSaved(result: boolean) {
        this.showModal = false;

        if (result) {
            this.refreshList = true;
        }
    }

    onOperationDeleted() {
        this.showModal = false;
        this.refreshList = true;
    }

    addNewOperation() {
        this.operationId = '';
        this.modalTitle = this.$t('modal.newOperationTitle') as string;
        this.showModal = true;
    }

    onFilterList(filter: OperationFilterOptions) {
        this.filter = filter;
        this.refreshList = true;
    }
}
